import { useState, useEffect, useCallback } from "react";
import { ITEMS_PER_PAGE } from "../../../constants";
import {
  showErrorToast,
  getAllAmbientScreeningSubmissions,
} from "../../../helpers";
import { getSelectedJournalIds } from "../../../helpers/journals";

const useAmbientScreenedManuscripts = ({ type }) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [fetchParams, setFetchParams] = useState({
    currentPage: 0,
    searchTerm: "",
    type,
  });

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(false);

      const selectedJournalIds = await getSelectedJournalIds();

      const { currentPage, searchTerm, type } = fetchParams;
      let reports, total;
      ({ data: { manuscripts: reports = [], total = 0 } = {} } =
        await getAllAmbientScreeningSubmissions(
          currentPage * ITEMS_PER_PAGE + 1,
          ITEMS_PER_PAGE,
          searchTerm,
          type,
          selectedJournalIds
        ));
      setData(reports);
      setPageCount(Math.ceil(total / ITEMS_PER_PAGE));
    } catch {
      showErrorToast();
      setError(true);
    } finally {
      setIsLoading(false);
    }
  }, [fetchParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const updateFetchParams = (newParams) => {
    setFetchParams((prev) => ({
      ...prev,
      ...newParams,
      currentPage:
        newParams.currentPage !== undefined
          ? newParams.currentPage
          : prev.currentPage,
    }));
  };

  return {
    data,
    setData,
    fetchData,
    error,
    pageCount,
    currentPage: fetchParams.currentPage,
    searchTerm: fetchParams.searchTerm,
    setSearchTerm: (term) =>
      updateFetchParams({ searchTerm: term, currentPage: 0 }),
    setCurrentPage: (page) => updateFetchParams({ currentPage: page }),
    isLoading,
  };
};

export default useAmbientScreenedManuscripts;
